import React from "react";
import {
  CareerManagersFiltersEnum,
  CertificationsFiltersEnum,
  CollaboratorHistoryProjectsFiltersEnum,
  CollaboratorsFiltersEnum,
  CoursesFiltersEnum,
  FontWeightEnum,
  IconSizeEnum,
} from "../types/AppTypes";
import { BodyTyp } from "../components/Typography/Typography";
import {
  COMPANY_ORGANIZATION_LABEL,
  COLLABORATIVE_RELATIONSHIP_LABEL,
  PC_STATUS_LABEL,
  FEATURES_LABEL,
  CM_LABEL,
  TIMELINE_LABEL,
  DETAILS_LABEL,
  TECH_SKILLS_LABEL,
} from "./Dictionary";
import { ReactComponent as OrganizationIcon } from "../icons/organization.svg";
import { ReactComponent as CareerManagerIcon } from "../icons/careerManager.svg";
import { ReactComponent as FeaturesIcon } from "../icons/features.svg";
import { ReactComponent as GraduationIcon } from "../icons/graduation.svg";
import { ReactComponent as CertificateIcon } from "../icons/certificate.svg";
import { ReactComponent as DetailsIcon } from "../icons/details.svg";
import { ReactComponent as CalendarDateIcon } from "../icons/calendar-date.svg";
import { IconManager } from "../components/core/IconManager/IconManager";
import { theme } from "./StyledComponents";
import { CollaboratorTypeEnum } from "./AppConstants";

export type FiltersTitles = {
  key: string;
  label: React.ReactNode;
};

export const getCollaboratorsFiltersTitles = (
  selectedCollaboratorType: CollaboratorTypeEnum,
): FiltersTitles[] => {
  return [
    {
      key: CollaboratorsFiltersEnum.ORG,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <OrganizationIcon />
          </IconManager>
          {COMPANY_ORGANIZATION_LABEL}
        </BodyTyp>
      ),
    },
    {
      key: CollaboratorsFiltersEnum.RELATION,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <CareerManagerIcon />
          </IconManager>
          {COLLABORATIVE_RELATIONSHIP_LABEL}
        </BodyTyp>
      ),
    },
    ...(selectedCollaboratorType === CollaboratorTypeEnum.ACTIVE
      ? [
          {
            key: CollaboratorsFiltersEnum.CM_STATE,
            label: (
              <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
                <IconManager
                  color={theme.colors.black}
                  size={IconSizeEnum.SMALL}
                  marginRight={10}
                >
                  <GraduationIcon />
                </IconManager>
                {PC_STATUS_LABEL}
              </BodyTyp>
            ),
          },
        ]
      : []),
    ...(selectedCollaboratorType === CollaboratorTypeEnum.ACTIVE
      ? [
          {
            key: CollaboratorsFiltersEnum.TECH_SKILLS,
            label: (
              <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
                <IconManager
                  color={theme.colors.black}
                  size={IconSizeEnum.SMALL}
                  marginRight={10}
                >
                  <CertificateIcon />
                </IconManager>
                {TECH_SKILLS_LABEL}
              </BodyTyp>
            ),
          },
        ]
      : []),
  ];
};

export const getConfigCollaboratorsFiltersTitles = (): FiltersTitles[] => {
  return [
    {
      key: CollaboratorsFiltersEnum.ORG,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <OrganizationIcon />
          </IconManager>
          {COMPANY_ORGANIZATION_LABEL}
        </BodyTyp>
      ),
    },
    {
      key: CollaboratorsFiltersEnum.RELATION_CM_SHEET,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <GraduationIcon />
          </IconManager>
          {CM_LABEL}
        </BodyTyp>
      ),
    },
    {
      key: CollaboratorsFiltersEnum.RELATION,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <CareerManagerIcon />
          </IconManager>
          {COLLABORATIVE_RELATIONSHIP_LABEL}
        </BodyTyp>
      ),
    },
  ];
};

export const getCoursesFiltersTitles = (): FiltersTitles[] => {
  return [
    {
      key: CoursesFiltersEnum.ORG,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <OrganizationIcon />
          </IconManager>
          {COMPANY_ORGANIZATION_LABEL}
        </BodyTyp>
      ),
    },
    {
      key: CoursesFiltersEnum.FEATURE,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <FeaturesIcon />
          </IconManager>
          {FEATURES_LABEL}
        </BodyTyp>
      ),
    },
  ];
};

export const getCertificationsFiltersTitles = (): FiltersTitles[] => {
  return [
    {
      key: CertificationsFiltersEnum.ORG,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <OrganizationIcon />
          </IconManager>
          {COMPANY_ORGANIZATION_LABEL}
        </BodyTyp>
      ),
    },
    {
      key: CertificationsFiltersEnum.FEATURE,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <FeaturesIcon />
          </IconManager>
          {FEATURES_LABEL}
        </BodyTyp>
      ),
    },
  ];
};

export const getCareerManagersFiltersTitles = (): FiltersTitles[] => {
  return [
    {
      key: CareerManagersFiltersEnum.ORG,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <OrganizationIcon />
          </IconManager>
          {COMPANY_ORGANIZATION_LABEL}
        </BodyTyp>
      ),
    },
    {
      key: CareerManagersFiltersEnum.RELATION,
      label: (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
          <IconManager
            color={theme.colors.black}
            size={IconSizeEnum.SMALL}
            marginRight={10}
          >
            <GraduationIcon />
          </IconManager>
          {COLLABORATIVE_RELATIONSHIP_LABEL}
        </BodyTyp>
      ),
    },
  ];
};

export const getCollaboratorHistoryProjectsFiltersTitles =
  (): FiltersTitles[] => {
    return [
      {
        key: CollaboratorHistoryProjectsFiltersEnum.TIMELINE,
        label: (
          <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
            <IconManager
              color={theme.colors.black}
              size={IconSizeEnum.SMALL}
              marginRight={10}
            >
              <CalendarDateIcon />
            </IconManager>
            {TIMELINE_LABEL}
          </BodyTyp>
        ),
      },
      {
        key: CollaboratorHistoryProjectsFiltersEnum.DETAILS,
        label: (
          <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
            <IconManager
              color={theme.colors.black}
              size={IconSizeEnum.SMALL}
              marginRight={10}
            >
              <DetailsIcon />
            </IconManager>
            {DETAILS_LABEL}
          </BodyTyp>
        ),
      },
    ];
  };
